import {translations} from 'presentation/translations-new';
import {ContactEntry} from './types';
const {
	contactSacLabel,
	contactWhatsAppPhoneLabel,
	contactWhatsAppLabel,
	contactEmailLabel,
	contactPortalLabel,
} = translations['pt-br'].privateFlow.home.congenereDrawer;

const CONGENERE_STORAGE_KEY = 'congenereEligibilityStore';

const APP_URL = 'https://play.google.com/store/apps/details?id=br.com.suldoparasaude.app';
const PORTAL_URL = 'https://www.spssaude.com.br';

const CONTACTS: ContactEntry[] = [
	{
		iconName: 'phone-filled',
		label: contactSacLabel,
		linkText: '0800 941 1196',
		href: 'tel:08009411196',
	},
	{
		iconName: 'whatsapp-filled',
		label: contactWhatsAppPhoneLabel,
		linkText: '(94) 99284-0922',
		href: 'https://wa.me/5594992840922',
	},
	{
		iconName: 'whatsapp-filled',
		label: contactWhatsAppLabel,
		linkText: '(61) 99159-0196',
		href: 'https://wa.me/5561991590196',
	},
	{
		iconName: 'mail-filled',
		label: contactEmailLabel,
		linkText: 'sac@suldoparasaude.com.br',
		href: 'mailto:sac@suldoparasaude.com.br',
	},
	{
		iconName: 'website-outline',
		label: contactPortalLabel,
		linkText: 'www.spssaude.com.br',
		href: PORTAL_URL,
	},
];

export {APP_URL, PORTAL_URL, CONTACTS, CONGENERE_STORAGE_KEY};
